var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/membercard"
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondarytint",
    d: "M15.75 4.5a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 1 0 0-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16.5v2.7c0 .45.35.8.8.8h17.9c.45 0 .8-.35.8-.8v-2.7H3.5z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 5H2.6c-.35 0-.6.25-.6.6v12.85c0 .3.25.6.6.6h19.35c.3 0 .6-.25.6-.6V5.6c-.05-.35-.3-.6-.65-.6zm-.4 13H3v-2h18.5v2zm0-3H3V6h18.5v9zm-5.75-4.5c.95 0 1.75-.8 1.75-1.75S16.7 7 15.75 7 14 7.8 14 8.75s.8 1.75 1.75 1.75zm0-2.5c.4 0 .75.35.75.75s-.35.75-.75.75-.75-.35-.75-.75.35-.75.75-.75zM4.5 9c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5zm0 2c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5zm9.05 3h-1c.15-1.7 1.55-3 3.25-3s3.1 1.3 3.25 3h-1c-.15-1.1-1.05-2-2.2-2-1.15 0-2.2.9-2.3 2z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembercard);
export default __webpack_public_path__ + "static/media/membercard.be941483fc156713b65601dc9956a16f.svg";
export { ForwardRef as ReactComponent };